/* Officer Tatum — CRO draft layer: "Add both" pair form + quick-add sheet housekeeping. */
(function () {
  'use strict';
  function toast(msg) {
    var t = document.getElementById('CartToast'); if (!t) return;
    t.querySelector('span').textContent = msg; t.hidden = false;
    clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, 3500);
  }
  function refreshCount() {
    fetch(window.theme.cartUrl + '.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.items.reduce(function (n, i) { return n + (i.handle === "tatum-secured-shipping-insurance" ? 0 : i.quantity); }, 0); });
    }).catch(function () {});
  }

  /* Complete the fit: add both variants in one request */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-fit-form]'); if (!form) return;
    e.preventDefault();
    var ids = [form.elements['fit-1'], form.elements['fit-2']].map(function (el) { return el && el.value; });
    if (ids.some(function (id) { return !id; })) { toast('Pick a size and color first'); return; }
    var btn = form.querySelector('[type="submit"]'); var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch(window.theme.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { toast(res.description || 'Could not add to cart'); return; }
      refreshCount(); if (!window.TatumCart || !window.TatumCart.open()) toast('Added both to your cart');
    }).catch(function () { toast('Could not add to cart'); })
      .finally(function () { btn.disabled = false; btn.textContent = label; });
  });

  /* Quick-add size sheet: close after a size is added, and when tapping elsewhere */
  document.addEventListener('submit', function (e) {
    var d = e.target.closest('details.qa'); if (d) setTimeout(function () { d.open = false; }, 400);
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.qa[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
  });
})();

/* Vitals sticky add-to-cart: Vitals copies its label from the FIRST button in the theme's product form (our qty "−"),
   so the bar always read "−". In stock → label it "Add to Cart" (Vitals still handles the tap).
   Sold out → "Notify when available", opening Vitals' own back-in-stock form. */
(function () {
  'use strict';
  var json = document.getElementById('ProductJson'); if (!json) return;
  var product; try { product = JSON.parse(json.textContent); } catch (e) { return; }
  var LABEL = 'Notify when available';
  var ADD = 'Add to Cart';

  function currentVariantId(bar) {
    var picker = bar.querySelector('[data-selected-value]');
    var id = picker && picker.getAttribute('data-selected-value');
    if (!id) { var input = document.querySelector('#ProductForm input[name="id"]'); id = input && input.value; }
    return id ? Number(id) : null;
  }
  function isSoldOut(id) {
    var v = product.variants.find(function (x) { return x.id === id; });
    return v ? !v.available : !product.available;
  }
  function apply() {
    var bar = document.querySelector('.Vtl-StickyAddToCart'); if (!bar) return;
    var btn = bar.querySelector('.Vtl-StickyAddToCart__AddToCartButton'); if (!btn) return;
    var soldOut = isSoldOut(currentVariantId(bar));
    if (soldOut && !btn.classList.contains('is-notify')) {
      if (!btn.hasAttribute('data-orig-html')) btn.setAttribute('data-orig-html', btn.innerHTML);
      btn.classList.add('is-notify'); btn.removeAttribute('disabled'); btn.setAttribute('aria-disabled', 'false');
      btn.textContent = LABEL; btn.setAttribute('aria-label', LABEL);
    } else if (soldOut && btn.textContent.trim() !== LABEL) {
      btn.textContent = LABEL; btn.removeAttribute('disabled');
    } else if (!soldOut) {
      if (btn.classList.contains('is-notify')) { btn.classList.remove('is-notify'); btn.removeAttribute('aria-label'); }
      if (btn.textContent.trim() !== ADD) btn.textContent = ADD;
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.Vtl-StickyAddToCart__AddToCartButton.is-notify'); if (!btn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var bis = document.querySelector('.Vtl-BackInStockButton');
    if (bis) bis.click();
    else { var atc = document.querySelector('#ProductForm'); if (atc) atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }, true);
  var pending = false;
  new MutationObserver(function () {
    if (pending) return; pending = true;
    requestAnimationFrame(function () { pending = false; apply(); });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-selected-value', 'disabled', 'class'] });
  apply();
})();

/* Slide-out cart (sections/cart-drawer.liquid). Opens after any add-to-cart and from the header cart link;
   quantity / remove / one-tap add-ons / note all go through the Ajax Cart API and re-render the section — no page reloads.
   Also: cart-page quantity changes re-render the cart section instead of reloading. */
(function () {
  'use strict';
  var lastFocus = null, busy = false;
  function root() { return document.querySelector('[data-cart-drawer]'); }
  function setCount(n) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function render() {
    return fetch(window.location.pathname + '?sections=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var el = root(); if (!el || !data['cart-drawer']) return;
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]'); if (!fresh) return;
        var wasOpen = !el.hidden;
        el.innerHTML = fresh.innerHTML;
        el.hidden = !wasOpen;
        var n = el.querySelector('#CartDrawerTitle span'); if (n) setCount(n.textContent.replace(/\D/g, '') || 0);
      });
  }
  function open() {
    var el = root(); if (!el) return false;
    lastFocus = document.activeElement;
    render().then(function () {
      el.hidden = false; document.documentElement.classList.add('cd-open');
      requestAnimationFrame(function () { el.classList.add('is-open'); var p = el.querySelector('.cd-panel'); if (p) p.focus({ preventScroll: true }); });
    }).catch(function () { window.location.href = window.theme.cartUrl; });
    return true;
  }
  function close() {
    var el = root(); if (!el || el.hidden) return;
    el.classList.remove('is-open'); document.documentElement.classList.remove('cd-open');
    setTimeout(function () { el.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function act(promise, btn) {
    if (busy) return; busy = true;
    var el = root(); if (el) el.classList.add('is-busy');
    if (btn) btn.disabled = true;
    promise.then(function (res) {
      if (res && res.status && res.description) alert(res.description);
      return render();
    }).catch(function () {}).finally(function () { busy = false; var e = root(); if (e) e.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var link = t.closest && t.closest('a.header-cart, a[href="/cart"][data-cd-open]');
    if (link && root()) { e.preventDefault(); open(); return; }
    if (!root() || !root().contains(t)) return;
    if (t.closest('[data-cd-close]')) { close(); return; }
    var q = t.closest('[data-cd-qty]');
    if (q) { var line = Number(q.closest('[data-line]').getAttribute('data-line')); act(post(window.theme.cartChangeUrl + '.js', { line: line, quantity: Number(q.getAttribute('data-cd-qty')) }), q); return; }
    var a = t.closest('[data-cd-add]');
    if (a) { act(post(window.theme.cartAddUrl + '.js', { items: [{ id: Number(a.getAttribute('data-cd-add')), quantity: 1 }] }), a); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  var nt;
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-cd-note]')) return;
    clearTimeout(nt); var v = e.target.value;
    nt = setTimeout(function () { post('/cart/update.js', { note: v }); }, 500);
  });

  /* Cart page: re-render the cart section after a quantity change (capture phase so the old reload handler never runs) */
  function refreshPage() {
    var sec = document.querySelector('[id^="Cart-"]'); if (!sec) { location.reload(); return; }
    var id = sec.id.replace(/^Cart-/, '');
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id)).then(function (r) { return r.json(); }).then(function (data) {
      var doc = new DOMParser().parseFromString(data[id], 'text/html'); var fresh = doc.getElementById(sec.id);
      if (!fresh) { location.reload(); return; }
      sec.innerHTML = fresh.innerHTML;
      fetch(window.theme.cartUrl + '.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.items.reduce(function (n, i) { return n + (i.handle === "tatum-secured-shipping-insurance" ? 0 : i.quantity); }, 0)); });
    }).catch(function () { location.reload(); });
  }
  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('[data-line-qty]'); if (!inp) return;
    e.stopPropagation();
    inp.disabled = true;
    post(window.theme.cartChangeUrl + '.js', { line: Number(inp.getAttribute('data-line-qty')), quantity: Math.max(0, parseInt(inp.value, 10) || 0) })
      .then(refreshPage).catch(function () { location.reload(); });
  }, true);

  /* Opt-in Package Protection (snippets/package-protection.liquid): tick adds it, untick removes it, then re-render
     whichever cart the checkbox lives in. */
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-pp-toggle]'); if (!box) return;
    var id = Number(box.getAttribute('data-pp-toggle'));
    var req = box.checked
      ? post(window.theme.cartAddUrl + '.js', { items: [{ id: id, quantity: 1 }] })
      : post(window.theme.cartChangeUrl + '.js', { id: String(id), quantity: 0 });
    if (root() && root().contains(box)) { act(req, box); return; }
    box.disabled = true;
    req.then(refreshPage).catch(function () { location.reload(); });
  });

  window.TatumCart = { open: open, close: close, render: render, refreshPage: refreshPage };
})();

/* "Get notified" on sold-out product cards: opens a back-in-stock popup right on the collection page (no trip to the
   product page). Submits to Vitals' own back-in-stock endpoint (same request its product-page popup sends), so
   subscribers land in Vitals and get its restock emails. Falls back to the product page if anything fails. */
(function () {
  'use strict';
  var ENDPOINT = 'https://appsolve.io/bundle/api/v2/sf/bis';
  var modal, lastFocus;
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function build() {
    modal = document.createElement('div'); modal.className = 'bis'; modal.hidden = true;
    modal.innerHTML = '<div class="bis-backdrop" data-bis-close></div><div class="bis-card" role="dialog" aria-modal="true" aria-labelledby="BisTitle" tabindex="-1">' +
      '<button type="button" class="bis-x" data-bis-close aria-label="Close">&times;</button><h2 id="BisTitle">Notify me when back in stock</h2><div class="bis-body"></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-bis-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) close(); });
  }
  function close() { modal.hidden = true; document.documentElement.classList.remove('bis-open'); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }
  function open(handle) {
    if (!modal) build();
    lastFocus = document.activeElement;
    var body = modal.querySelector('.bis-body'); body.innerHTML = '<p class="bis-muted">Loading…</p>';
    modal.hidden = false; document.documentElement.classList.add('bis-open'); modal.querySelector('.bis-card').focus({ preventScroll: true });
    fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
      var out = p.variants.filter(function (v) { return !v.available; }); if (!out.length) out = p.variants;
      var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
      var pick = out.length > 1
        ? '<label class="bis-label" for="BisVariant">Size / option</label><select id="BisVariant" class="bis-input">' + out.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>'
        : '<input type="hidden" id="BisVariant" value="' + out[0].id + '">' + (p.variants.length > 1 ? '<p class="bis-chip">' + esc(out[0].title) + '</p>' : '');
      body.innerHTML = '<p class="bis-muted">Enter your email and we\'ll let you know as soon as it\'s back.</p>' +
        '<div class="bis-prod">' + (img ? '<img src="' + esc(img) + '" alt="" width="120" height="120">' : '') + '<div><p class="bis-name">' + esc(p.title) + '</p>' + pick + '</div></div>' +
        '<form class="bis-form" novalidate><label class="bis-label" for="BisEmail">Email</label><input id="BisEmail" class="bis-input" type="email" required autocomplete="email" placeholder="you@example.com">' +
        '<p class="bis-err" hidden></p><button type="submit" class="btn btn-red bis-submit">Notify me when available</button></form>';
      var form = body.querySelector('form'), email = form.querySelector('#BisEmail'), err = form.querySelector('.bis-err');
      setTimeout(function () { email.focus(); }, 50);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var val = email.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) { err.textContent = 'Please enter a valid email.'; err.hidden = false; email.focus(); return; }
        err.hidden = true; var btn = form.querySelector('button'); btn.disabled = true; btn.textContent = 'Saving…';
        fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain; charset=UTF-8' },
          body: JSON.stringify({ shopId: Number(window.theme.shopId), email: val, productId: String(p.id), variantId: String(body.querySelector('#BisVariant').value) }) })
          .then(function (r) { if (!r.ok) throw 0;
            body.innerHTML = '<div class="bis-done"><p class="bis-name">You\'re on the list.</p><p class="bis-muted">We\'ll email ' + esc(val) + ' when ' + esc(p.title) + ' is back in stock.</p><button type="button" class="btn btn-red" data-bis-close>Keep shopping</button></div>';
          }).catch(function () {
            btn.disabled = false; btn.textContent = 'Notify me when available';
            err.innerHTML = 'Something went wrong. <a href="' + esc(p.url) + '">Try on the product page</a>.'; err.hidden = false;
          });
      });
    }).catch(function () { window.location.href = '/products/' + handle; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-notify]'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); open(b.getAttribute('data-notify'));
  }, true);
})();
